import { useEffect, useState } from 'react'
import { useGetList, useLocaleState, useStore } from 'react-admin'
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import _ from 'lodash'
import { BookingSelectBranchProps } from './type'
import { BranchSelect } from '../../components/app-bar/type'

const BookingSelectBranch: React.FC<BookingSelectBranchProps> = ({
  label,
  onChange,
  value = '',
  defaultValue = '',
  excludeUnconfigured = false,
  disabled,
  ...props
}): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [globalBranch, setGlobalBranch] = useStore<BranchSelect>('branch.selected')
  const [locale] = useLocaleState()
  const [choices, setChoices] = useState([])
  const [defVal, setDefVal] = useState(defaultValue)
  const [loading, setLoading] = useState(true)

  const { data: allBranches, isLoading: allLoading } = useGetList('branches', {
    pagination: { page: 1, perPage: 50 },
    sort: { field: 'branch_code', order: 'ASC' },
    meta: { isPaginate: false },
  })

  const { data: unconfBranches, isLoading: unconfLoading } = useGetList('branches', {
    pagination: { page: 1, perPage: 50 },
    filter: { exclude: 'configured' },
    sort: { field: 'branch_code', order: 'ASC' },
    meta: { isPaginate: false },
  })

  useEffect(() => {
    if (!allLoading && allBranches && !unconfLoading && unconfBranches) {
      const confBranches = allBranches
        .filter((conf) => !unconfBranches.some((unconf) => unconf.id === conf.id))
        .map((b) => b.branch_code)
      setChoices(
        _.map(allBranches, (b) => ({
          id: b.branch_code,
          title: `${b['branch_code']} ${b[`branch_name_${locale}`] || b['branch_name_th']}`,
          disabled: !confBranches.includes(b.branch_code),
        })),
      )
      if (confBranches) {
        const def = value
          ? confBranches.includes(value)
            ? value
            : confBranches[0]
          : defVal
          ? confBranches.includes(defVal)
            ? defVal
            : confBranches[0]
          : confBranches[0]
        setDefVal(def)
        if (onChange && value == null) {
          onChange({ target: { value: def } })
        }
      }
      setLoading(false)
    }
  }, [allBranches, allLoading, unconfBranches, locale, unconfLoading, value, defVal, onChange])

  const handleChange = (event, newValue): void => {
    setGlobalBranch({ id: newValue.props.value, title: String(newValue.props.children).trim() })
    if (onChange) {
      onChange(event)
    }
  }

  return (
    <FormControl sx={{ m: '0.7rem 0' }} fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        {...props}
        value={loading ? 'loading' : defVal}
        onChange={handleChange}
        label={label}
        disabled={loading || disabled}
      >
        {!loading ? (
          choices.reduce((result, choice, idx) => {
            return excludeUnconfigured && choice.disabled
              ? result
              : [
                  ...result,
                  <MenuItem key={idx} value={choice.id} disabled={choice.disabled}>
                    {`${choice.title} ${choice.disabled ? '(ยังไม่ตั้งค่าการจอง)' : ''}`}
                  </MenuItem>,
                ]
          }, [])
        ) : (
          <MenuItem key={0} value='loading' disabled>
            Loading..
          </MenuItem>
        )}
      </Select>
    </FormControl>
  )
}

export default BookingSelectBranch
